/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TokenHelper, TokenHelperInterface } from "../TokenHelper";

const _abi = [
  {
    inputs: [],
    name: "TokenIsNotAContract",
    type: "error",
  },
];

const _bytecode =
  "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220c121ad81a4d1eddb7c527402f122937609718506685ef790c2dbf5225de403b564736f6c634300080d0033";

type TokenHelperConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TokenHelperConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TokenHelper__factory extends ContractFactory {
  constructor(...args: TokenHelperConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TokenHelper";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TokenHelper> {
    return super.deploy(overrides || {}) as Promise<TokenHelper>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TokenHelper {
    return super.attach(address) as TokenHelper;
  }
  connect(signer: Signer): TokenHelper__factory {
    return super.connect(signer) as TokenHelper__factory;
  }
  static readonly contractName: "TokenHelper";
  public readonly contractName: "TokenHelper";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TokenHelperInterface {
    return new utils.Interface(_abi) as TokenHelperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TokenHelper {
    return new Contract(address, _abi, signerOrProvider) as TokenHelper;
  }
}
